import React, { FC, useState } from 'react';
import { Create, CreateProps, FormTab, TabbedForm } from 'react-admin';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import BlogGeneralTab from './GeneralTab';
import UserToolbar from './BlogPostToolbar';
import './index.css';
import ImagesAssetsTab from './ImagesAssetsTab';

const AddUser: FC<CreateProps> = (props) => {
  const [state, setState] = useState({
    isBlocked: false,
  });

  const changeStatus = () => {
    setState({ ...state, isBlocked: !state.isBlocked });
  };

  return (
    <>
      <DocumentTitle
        core='Blog'
        secondary='Blog'
        purpose='Add new'
        appointment='Blog'
      />

      <Create {...props}>
        <TabbedForm toolbar={UserToolbar(props, true, state.isBlocked)}>
          <FormTab label='General'>
            <BlogGeneralTab
              isBlocked={state.isBlocked}
              changeStatus={changeStatus}
              isShow={false}
            />
          </FormTab>
          <FormTab label='Images Assets'>
            <ImagesAssetsTab
              isBlocked={state.isBlocked}
              changeStatus={changeStatus}
              isShow={false}
              record={undefined}
            />
          </FormTab>
        </TabbedForm>
      </Create>
    </>
  );
};

const Tabbed = () => {
  return <></>;
};

export default AddUser;
